import { defineStore } from 'pinia'
import { ref, computed, readonly } from 'vue'
import dayjs from 'dayjs'
import { FacilityType, GeneratorData, TrainingData } from '../_proto/landmake_pb'
import { sortExploreTeam } from '../utils/LandMakeUtil'

export const useLandMakeStore = defineStore('landMakeStore', () => {
  // state
  const landMakeInfo = ref<any>({})
  const decks = ref<any>([])
  const typeMaster = ref<any>([])
  const exporeResults = ref<any>([])

  // getters
  const getLandMakeInfo = computed(() => readonly(landMakeInfo.value))

  const getActiveLandType = computed(() => (id: Number) =>
    Object.keys(landMakeInfo.value).length
      ? landMakeInfo.value.activateLandMakeTypesList.find((x: number) => x === Number(id))
      : false
  )

  const getFacilityTypes = computed(() => readonly(FacilityType))
  const getGeneratorStatus = computed(() => readonly(GeneratorData.GeneratorStatus))
  const getTrainingStatus = computed(() => readonly(TrainingData.TrainingStatus))

  const getMyDeckData = computed(() => [...decks.value])

  const getTypeMaster = computed(() => (id: Number) =>
    readonly(typeMaster.value.find((x: any) => x.landMakeType === id) || {})
  )

  const getTypeMasters = computed(() => [...typeMaster.value])

  const getExploreResults = computed(() => [...exporeResults.value])

  const isExploreComplete = computed(() => {
    return exporeResults.value.some((x: any) => x.status === 6)
  })

  // useHeroStoreのfetchHeroes用
  // 探検結果からヒーローIDを取得して、fetchの時に必ず最新のユニット情報を取得
  const getExporeResultHeroIds = computed(() => {
    const heroIds = []
    exporeResults.value.forEach((x: any) => {
      if (x.until < dayjs().unix()) {
        const deck = decks.value.find((y: any) => y.no === x.deckNo)
        if (deck) {
          deck.item.unitsList.forEach((y: any) => {
            heroIds.push(y.heroId)
          })
        }
      }
    })

    return heroIds
  })

  // actions
  async function fetchLandMakeInfo() {
    const data = await this.$nuxt.$landMakeService.getCurrnetLandMakeInfo()
    landMakeInfo.value = data
  }

  function updateLandMakeInfo(data: any) {
    landMakeInfo.value = data
  }

  async function fetchLandMakeMaster() {
    const res = await this.$nuxt.$landMakeService.getLandMakeTypeMaster()
    typeMaster.value = res
  }

  async function fetchExploreResults(force: boolean = false) {
    if (!decks.value.length || force) {
      const res = await this.$nuxt.$teamsService.getMyOwnExploresTeam()
      decks.value = sortExploreTeam(res)
    }
    exporeResults.value = await this.$nuxt.$landMakeService.getExploreResults()
  }

  async function setMyDeckData(n, unitsList) {
    await this.$nuxt.$teamsService.setMyLandExploreDeck(n, unitsList)
    const res = await this.$nuxt.$teamsService.getMyOwnExploresTeam()
    decks.value = sortExploreTeam(res)
  }

  return {
    landMakeInfo,
    decks,
    typeMaster,
    getLandMakeInfo,
    getActiveLandType,
    getFacilityTypes,
    getGeneratorStatus,
    getTrainingStatus,
    getMyDeckData,
    getTypeMaster,
    getTypeMasters,
    getExploreResults,
    isExploreComplete,
    getExporeResultHeroIds,
    fetchLandMakeInfo,
    updateLandMakeInfo,
    fetchLandMakeMaster,
    fetchExploreResults,
    setMyDeckData,
  }
})
